import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

export default styled.div`
  display: grid;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    'order-label order-value'
    'seller-label seller-value'
    'shipping-label shipping-value';

  ${upTo('sm')`
    grid-row-gap: 0;
    grid-template-areas:
        'order-label order-label'
        'order-value order-value'
        'seller-label seller-label'
        'seller-value seller-value'
        'shipping-label shipping-label'
        'shipping-value shipping-value';
  `}
`;
